<template>
  <block-item-card
    :title="$t('ALM.Section.ALMix.Title')"
    :title-info="$t('ALM.Section.ALMix.TitleInfo')"
    :tooltip="$t('ALM.Section.ALMix.Tooltip')"
    :min-width="310"
  >
    <v-row class="ma-0 pb-5">
      <v-col
        class="px-4 py-2"
        cols="6"
      >
        <div
          style="background-color: #F7F9FC; border-radius: 8px;"
          class="pa-2"
        >
          <h3 class="synthesis-text text-size-16 font-weight-medium synthesis-brand-dark-blue--text mb-1 text-center">
            {{ $t('ALM.Section.ALMix.Assets.Title') }}
          </h3>
          <div style="width:80px;margin:auto; margin-top: 22px; margin-bottom: 12px;">
            <v-lazy
              :options="{threshold: .5}"
              transition="fade-transition"
            >
              <base-e-chart-pie
                :chart-animation="false"
                :chart-data-options="loansPieValues"
                :pie-radius="40"
                :pie-width="80"
                :chart-height="80"
                :chart-width="80"
                :tooltip-show="false"
                chart-animation-easing="elasticOut"
                :label-line-show="false"
                :label-show="false"
                :legend-show="false"
                :default-colors="assetsColors"
                :emphasis-disabled="true"
                :start-angle="0"
                style="pointer-events: none;"
                :pie-shadow-blur="5"
                :pie-shadow-color="'rgba(61, 104, 213, 0.15)'"
              />
            </v-lazy>
          </div>
          <div class="card">
            <div class="label">
              <span
                span
                class="text-size-10"
              >{{ $t('ALM.Section.ALMix.Assets.Loans') }}</span>
              <hr>
              <span class="text-size-10">{{ $t('ALM.Section.ALMix.Assets.Title') }}</span>
            </div>
            <div class="percent">
              <span>{{ loansPercentage }}%</span>
            </div>
          </div>
          <div style="width:80px;margin:auto; margin-top: 22px; margin-bottom: 12px;">
            <v-lazy
              :options="{threshold: .5}"
              transition="fade-transition"
            >
              <base-e-chart-pie
                :chart-data-options="investmentsPieValues"
                :chart-height="80"
                :chart-width="80"
                :pie-radius="40"
                :tooltip-show="false"
                chart-animation-easing="elasticOut"
                tooltip-confine
                :label-line-show="false"
                :label-show="false"
                :legend-show="false"
                :default-colors="assetsColors"
                :emphasis-disabled="true"
                :start-angle="0"
                style="pointer-events: none;"
                :pie-shadow-blur="5"
                :pie-shadow-color="'rgba(61, 104, 213, 0.15)'"
              />
            </v-lazy>
          </div>
          <div class="card">
            <div class="label">
              <span
                span
                class="text-size-10"
              >{{ $t('ALM.Section.ALMix.Assets.Investments') }}</span>
              <hr>
              <span class="text-size-10">{{ $t('ALM.Section.ALMix.Assets.Title') }}</span>
            </div>
            <div class="percent">
              <span>{{ investmentsPercentage }}%</span>
            </div>
          </div>
        </div>
      </v-col>

      <v-col
        class="px-4 py-2"
        cols="6"
      >
        <div
          style="background-color: #F7F9FC; border-radius: 8px;"
          class="pa-2"
        >
          <h3 class="synthesis-text text-size-16 font-weight-medium synthesis-brand-dark-blue--text mb-1 text-center">
            {{ $t('ALM.Section.ALMix.Liabilities.Title') }}
          </h3>
          <div style="width:80px;margin:auto; margin-top: 22px; margin-bottom: 12px;">
            <v-lazy
              :options="{threshold: .5}"
              transition="fade-transition"
            >
              <base-e-chart-pie
                :chart-data-options="depositsPieValues"
                :chart-height="80"
                :chart-width="80"
                :pie-radius="40"
                :tooltip-show="false"
                chart-animation-easing="elasticOut"
                tooltip-confine
                :label-line-show="false"
                :label-show="false"
                :legend-show="false"
                :default-colors="liabilitiesColors"
                :emphasis-disabled="true"
                :start-angle="0"
                style="pointer-events: none;"
                :pie-shadow-blur="5"
                :pie-shadow-color="'rgba(61, 104, 213, 0.15)'"
              />
            </v-lazy>
          </div>
          <div class="card">
            <div class="label">
              <span
                span
                class="text-size-10"
              >{{ $t('ALM.Section.ALMix.Liabilities.Deposits') }}</span>
              <hr>
              <span class="text-size-10">{{ $t('ALM.Section.ALMix.Liabilities.Title') }}</span>
            </div>
            <div class="percent">
              <span>{{ depositsPercentage }}%</span>
            </div>
          </div>

          <div style="width:80px;margin:auto; margin-top: 22px; margin-bottom: 12px;">
            <v-lazy
              :options="{threshold: .5}"
              transition="fade-transition"
            >
              <base-e-chart-pie
                :chart-data-options="equityPieValues"
                :chart-height="80"
                :chart-width="80"
                :pie-radius="40"
                :tooltip-show="false"
                chart-animation-easing="elasticOut"
                tooltip-confine
                :label-line-show="false"
                :label-show="false"
                :legend-show="false"
                :default-colors="liabilitiesColors"
                :emphasis-disabled="true"
                :start-angle="0"
                style="pointer-events: none;"
                :pie-shadow-blur="5"
                :pie-shadow-color="'rgba(61, 104, 213, 0.15)'"
              />
            </v-lazy>
          </div>
          <div class="card">
            <div class="label">
              <span
                span
                class="text-size-10"
              >{{ $t('ALM.Section.ALMix.Liabilities.Equity') }}</span>
              <hr>
              <span class="text-size-10">{{ $t('ALM.Section.ALMix.Liabilities.Title') }}</span>
            </div>
            <div class="percent">
              <span>{{ equityPercentage }}%</span>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import BaseEChartPie from '@/theme/default/components/charts/echarts/BaseEChartPie'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'

export default {
  name      : 'ALMix',
  components: {
    BlockItemCard,
    BaseEChartPie
  },
  mixins: [chartsColorMixin],
  props : {
    minBlockHeight: {
      type   : [Number, String],
      default: 400
    }
  },
  dataStore: {
    ALMSummary: 'ALM.ALMSummary.Data'
  },
  computed: {
    almSummary () {
      return this.ALMSummary || null
    },
    loansPieValues () {
      return this.almSummary?.LoansPieData || []
    },
    investmentsPieValues () {
      return this.almSummary?.InvestmentsPieData || []
    },
    depositsPieValues () {
      return this.almSummary?.DepositsPieData || []
    },
    equityPieValues () {
      return this.almSummary?.EquityPieData || []
    },
    loansPercentage () {
      return this.almSummary?.AssetsPercentages?.loans || 0
    },
    investmentsPercentage () {
      return this.almSummary?.AssetsPercentages?.investments || 0
    },
    depositsPercentage () {
      return this.almSummary?.LiabilitiesPercentages?.deposits || 0
    },
    equityPercentage () {
      return this.almSummary?.LiabilitiesPercentages?.equity || 0
    },
    assetsColors () {
      return [
        '#57C05B',
        '#FFFFFF'
      ]
    },
    liabilitiesColors () {
      return [
        '#EA804B',
        '#FFFFFF'
      ]
    }

  }
}
</script>

<style scoped>
.card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.label {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  color: #63747D;
}

.label hr {
  width: 100%;
  border: none;
  border-top: 0.5px solid #63747D;
  margin: 0.2rem 0;
}

.percent {
  font-weight: 500;
  color: #041F30;
}
</style>
